let path = require('path');
const basename = path.basename('react-interciew');
let pwd = path.resolve(__dirname, '..');
if (!pwd.includes(basename)) {
  pwd = path.resolve(pwd, basename);
}

const db = require('./config.db');

/**
 * 服务器server以及项目的公共配置
 */
module.exports = {
  publicPath: '/',    // 服务器部署路径
  staticPath: path.resolve(pwd, '..', 'dist'),    // 导出地址
  db,
};